import { render } from "./MomentButton.vue?vue&type=template&id=814a6cb2"
import script from "./MomentButton.vue?vue&type=script&lang=js"
export * from "./MomentButton.vue?vue&type=script&lang=js"

import "./MomentButton.vue?vue&type=style&index=0&id=814a6cb2&lang=scss"
script.render = render

export default script